export function PageHeader({ eyebrow, title, description, action, testId }) {
  return (
    <div data-testid={testId} className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8">
      <div>
        {eyebrow && <div className="label-eyebrow mb-2">{eyebrow}</div>}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-base md:text-lg text-muted-foreground max-w-2xl">{description}</p>
        )}
      </div>
      {action && <div className="flex items-center gap-2">{action}</div>}
    </div>
  );
}
